import React, { Component } from 'react'
import { Col, Row, Skeleton, Empty, Collapse } from 'antd';
import style from './style.module.css'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { getMaterias } from '../../actions/Materias.action'
import { Link } from 'react-router-dom'
import { LinkOutlined } from '@ant-design/icons'
import BarraHistorico from '../../components/BarraHistorico'
import RenderHelmet from '../../components/RenderHelmet'
import { withRouter } from "react-router"

import ReactGA from "react-ga4";
import { GA_TRACKING_ID } from "../../configs/config";

const { Panel } = Collapse;

class Disciplinas extends Component {

  componentDidMount = () => {
    ReactGA.initialize(GA_TRACKING_ID);
    ReactGA.send({ hitType: "pageview", page: "/disciplinas" });
    window.scrollTo(0, 0)
    this.props.getMaterias()
  }
  

  renderLoading = () => {
    return (
      <>
        <Col span={6}>
          <Skeleton active paragraph={{ rows: 4 }}></Skeleton>
        </Col>
        <Col span={6}>
          <Skeleton active paragraph={{ rows: 4 }}></Skeleton>
        </Col>
        <Col span={6}>
          <Skeleton active paragraph={{ rows: 4 }}></Skeleton>
        </Col>
        <Col span={6}>
          <Skeleton active paragraph={{ rows: 4 }}></Skeleton>
        </Col>
        <Col span={6}>
          <Skeleton active paragraph={{ rows: 4 }}></Skeleton>
        </Col>
        <Col span={6}>
          <Skeleton active paragraph={{ rows: 4 }}></Skeleton>
        </Col>
      </>
    )
  }

  renderDisciplina = (disciplina) => {
    if (!disciplina) return null
    const assuntos = disciplina.assuntos || []
    const rawQtd = disciplina.qtd_questoes
    const parsedQtd = rawQtd != null && rawQtd !== '' ? Number(rawQtd) : NaN
    const qtdQuestoes = Number.isFinite(parsedQtd)
      ? parsedQtd
      : assuntos.reduce((acc, a) => acc + (a.questoes || []).length, 0)
    return (
      <Col key={disciplina.id} style={{marginBottom: 48, width: '100%'}} sm={{ span: 24 }} md={{ span: 12 }}>
        <div className={style.boxDisciplina}>
          <h3 style={{ lineHeight: '1em' }}>{disciplina.nome}</h3>

          <Collapse bordered={false} className={style.collapse}>
            <Panel className={style.panel} header={<p className={style.panelHeader}>Assuntos: {assuntos.length}</p>}>
              {
                assuntos.map(assunto => {
                  return <p key={assunto.id} className={style.collapseContent}><Link to={`/questoes?assuntos[]=${assunto.id}`}><LinkOutlined /> {assunto.nome}</Link></p>
                })
              }
            </Panel>
          </Collapse>

          <p className="no-margin">
            <span className="strong no-margin">Total de: </span>
            <Link to={`/questoes?materias[]=${disciplina.id}`}><LinkOutlined /> {qtdQuestoes} questões</Link>
          </p>

        </div>
      </Col>
    )
  }

  renderDisplinas = (disciplinas) => {
    const lista = Array.isArray(disciplinas) ? disciplinas : []
    return lista.map(disciplina => {
      return this.renderDisciplina(disciplina)
    })
  }

  render() {
    const { loadMaterias, materias } = this.props.materias
    return (
      <div className="container">
        <RenderHelmet title={'Cade Direito: Disciplinas'} description={'Lista de disciplinas'}/>
        <BarraHistorico title={'Disciplinas'} match={ this.props.match }/>
        <Row gutter={[24,24]}>
          {
            materias
              ? this.renderDisplinas(materias)
              : (
                !loadMaterias
                  ? <Empty description="Não há disciplinas disponíveis" style={{ margin: '64px 0 128px 0' }} />
                  : <Skeleton active paragraph={{ rows: 12 }}></Skeleton>
              )
          }
        </Row>
      </div>
    )
  }
}

const mapStateToProps = state =>
  ({
    materias: state.materias
  })

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getMaterias }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Disciplinas))